var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpyLine = function SvgSpyLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17 12.898a3.601 3.601 0 1 1-3.6 3.6h-1.8a3.6 3.6 0 1 1-.482-1.8h2.764a3.6 3.6 0 0 1 3.118-1.8m-9 1.8a1.8 1.8 0 1 0 0 3.6 1.8 1.8 0 0 0 0-3.6m9 0a1.8 1.8 0 1 0 0 3.601 1.8 1.8 0 0 0 0-3.6Zm-.9-10.8a3.6 3.6 0 0 1 3.6 3.6v2.7h1.8v1.8h-18v-1.8h1.8v-2.7a3.6 3.6 0 0 1 3.6-3.6zm0 1.8H8.9c-.949 0-1.8.855-1.8 1.8v2.7h10.8v-2.7c0-.948-.855-1.8-1.8-1.8"
  })));
};
export default SvgSpyLine;